import React from 'react';
import Panel from './Panel';
import PlanRegistration from '../../components/Panel/Plans/PlanRegistration';

const PlanRegistrationPage = () => {

  return (
    <Panel>
      <div>
        <PlanRegistration />
      </div>
    </Panel>

  );
};

export default PlanRegistrationPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/PlanRegistration.js
 **/